import axios from "axios";
import CreatableSelect from "react-select/creatable";
import { useState } from "react";
import postToAPI from "../utils/postToAPI";

const SELECT_STYLES = {
  container: (provided) => ({
    ...provided,
    width: "calc(100% - 20px)",
    marginBottom: "20px",
    border: "none",
    backgroundColor: "#d1c5b2",
    color: "#2c434d",
    boxSizing: "content-box",
    padding: "10px",
  }),
  control: (provided) => ({
    ...provided,
    width: "100%",
    marginBottom: "10px",
    border: "none",
    padding: "0px",
    backgroundColor: "#d1c5b2",
    color: "#2c434d",
    boxSizing: "content-box",
    cursor: "pointer",
  }),
  menu: (provided) => ({
    ...provided,
    width: "98%",
    border: "none",
    boxSizing: "content-box",
    backgroundColor: "#d1c5b2",
    color: "#2c434d",
    cursor: "pointer",
  }),
};

const CreatableSelectField = (props) => {
  const [value, setValue] = useState([]);
  const [loading, setLoading] = useState(true);

  const { name, label, nameOptions, setNameOptions, tooltipInfo } = props;

  const createOption = (label) => ({
    label,
    value: label,
  });

  const handleChange = (newValues) => {
    setValue(newValues);
    props.onChange(newValues.map(v => v.value));
  };

  const handleSelectCreate = (inputValue) => {
    const newName = createOption(inputValue);
    const newValues = [...value, newName];
    setValue(newValues);
    setNameOptions((prev) => [...prev, newName]);
    props.onChange(newValues.map(v => v.value));
  };

  return (
    <div>
      <label htmlFor={name} className="form-label">
        {label}
        {tooltipInfo ? (
          <div className="tooltip">
            <span className="icon">i</span>
            <span className="tooltiptext">{tooltipInfo}</span>
          </div>
        ) : (
          ""
        )}
      </label>
      <CreatableSelect
        id={name}
        isClearable
        isMulti
        onChange={handleChange}
        onCreateOption={handleSelectCreate}
        options={nameOptions}
        value={value}
        styles={SELECT_STYLES}
        menuPortalTarget={document.getElementById("select-menu-portal")}
      />
      <input
        type="hidden"
        name={name}
        value={JSON.stringify(value.map((entry) => entry.value))}
      />
    </div>
  );
};

export default CreatableSelectField;
